import { isIOS } from "react-device-detect";

/**
 * Opens an external URL with the mechanism expected on each platform:
 * - Web: new tab via `window.open` (noopener).
 * - Cordova Android: `navigator.app.loadUrl` with `openExternal: true` (system browser).
 * - Cordova iOS: `InAppBrowser` with `_system` — `window.open` is unreliable inside WKWebView.
 *
 * @param {string} [url] Full URL (e.g. https://…)
 */
export default function openExternalUrl(url) {
    if (!url || typeof url !== "string") {
        return;
    }
    if (!window.cordova) {
        window.open(url, "_blank", "noopener noreferrer");
        return;
    }
    if (!isIOS) {
        window.navigator.app.loadUrl(url, { openExternal: true });
        return;
    }
    window.cordova.InAppBrowser.open(url, "_system", "hidden=no,location=no,clearsessioncache=yes,clearcache=yes");
}
